import axios from 'axios';

const getAllShops = () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/api/dealer`)
    .then(res => res)
    .catch(err => err);
};

export default getAllShops;
